import { useRecoilState } from "recoil";
import { useFetchWrapper } from "_helpers";
import { authAtom } from "_state";

export { useTokenActions };

function useTokenActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/Authentication`;
    const fetchWrapper = useFetchWrapper();
    const [auth, setAuth] = useRecoilState(authAtom);

    return {
        getToken,
        removeToken
    }

    function getToken() {
        let username = 'mFra2jnTQBGcNHU7nCB6GtQN';
        let password = 'bT2pFhKd7MbKn$5bzMdcgj8E';

        if (localStorage.getItem('user'))
            return Promise.resolve();

        return fetchWrapper.post(`${baseUrl}/token`, { username, password })
            .then(token => {
                localStorage.setItem('user', JSON.stringify(token));
                setAuth(token);
                return Promise.resolve();
            });
    }

    function removeToken() {
        // remove user from local storage, set auth state to null
        localStorage.removeItem('user');
        setAuth(null);
    }
}